import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "TableRow",
    standalone: false
})
export class TableRowPipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): unknown {
    const row = value;
    if (!row || !args?.length) return "";
    const rowFunction: any = args[0];
    const funValue: any = eval(rowFunction);
    if (typeof funValue === "string") {
      return funValue?.replace(/undefined|null/g, "-");
    } else {
      return funValue;
    }
  }
}
